import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
var _createReducer;
import { createReducer } from 'redux-act';
import { createNotification, closeNotification, closeAllNotifications } from './actions';
// $FlowFixMe[signature-verification-failure]
var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, createNotification, function (state, payload) {
  var clone = _toConsumableArray(state);
  var index = state.findIndex(function (el) {
    return el.id === payload.id;
  });
  if (index > -1) {
    clone[index] = payload;
    return clone;
  }
  return clone.concat(payload);
}), _defineProperty(_createReducer, closeNotification, function (state, payload) {
  return state.filter(function (message) {
    return message.id !== payload;
  });
}), _defineProperty(_createReducer, closeAllNotifications, function () {
  return [];
}), _createReducer), []);
export default reducer;